import React from 'react';

import i18n from 'i18next';
import { TabsContainer } from '@/exceed';

import { Loading } from 'uikit/loaders';

import InitiativeFormContainer from '../containers/initiativeFormContainer';
import InitiativeUsageContainer from '../containers/initiativeUsageContainer';
import InsightsDashboardsContainer from '../containers/insightsDashboardsContainer';

import styles from '../styles/editInitiative.module.scss';

const EditInitiative = ({ isLoading }) => (
  isLoading ? <Loading className={styles.loader} /> : (
    <TabsContainer
      id="editInitiative"
      shouldRenderAll={false}
      shouldUpdateInitialUrl
      tabs={[
        {
          id: 'insights',
          title: i18n.t('insights'),
          body: <InsightsDashboardsContainer />,
        },
        {
          id: 'properties',
          title: i18n.t('properties'),
          body: <InitiativeFormContainer />,
        },
        {
          id: 'usage',
          title: i18n.t('usage'),
          body: <InitiativeUsageContainer />,
        },
      ]}
    />
  )
);

export default React.memo(EditInitiative);
